module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/hiroos/hiroosTexture.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/hiroos/hiroosTexture.jpg
// module id = 572
// module chunks = 0